
















































import Vue from 'vue';
import UiSelectInput from '@/components/Ui/Inputs/SelectInput.vue';
import config from '@/config'
import {STUDENT_LIST_SORT} from '@/constants'

export default Vue.extend({
  name: 'UiPagination',
  components: {UiSelectInput},
  props: [
    'pagination',
    'documentsName',
    'count',
    'columnSelector',
    'selectedColumns',
    'paginationPage'
  ],
  methods: {
    onColumnSelectorInput (event: string[]) {
      this.$emit('columnSelection', event);
    }
  },
  data () {
    return {
      currentPage: +(
        this.$route.params.page || this.pagination.currentPage
      )
    };
  },
  computed: {
    currentSelectedColumns: {
      get () {
        // @ts-ignore
        if (typeof this.selectedColumns === 'string') {
          // @ts-ignore
          return this.selectedColumns.split(',')
        } else {
          // @ts-ignore
          return this.selectedColumns;
        }
      },
      set () {}
    },
    columnSelectorInner (): string[] {
      // @ts-ignore
      return this.columnSelector.filter(column => config(STUDENT_LIST_SORT).split(',').includes(column.value));
    }
  }
});
